export default __webpack_public_path__ + "static/akitabox_horizontal_white.64464e3000600eb5823577068beec29c.svg";